
const Colors = {
    main : "5E8B7B",
    accent: "76B29C"
}
class Font {
    constructor(regular,link) {
        this.regular = regular
        this.link = link
    }
}

class Theme {
    constructor(main,primary,secondary,tertiary,font,isMobile) {
        this.main = main
        this.primary = primary
        this.secondary = secondary
        this.tertiary = tertiary
        this.font = font
        this.colors = Colors
    }
}

export const darkTheme = new Theme(
    "#F9F9F9",
    "#121212",
    "#1C1C1E",
    "313135",
    new Font("#F9F9F9","#95959B"),
    false
);
export const lightTheme = new Theme(
    "#121212",
    "#F9F9F9",
    "#F5F5F7",
    "#F9F9F9",
    new Font("#121212","#1C1C1E"),
    false
);